<template>
	<div class="auto-grow-input" :class="{ 'auto-grow-input--disabled ': disabled }">
		<div class="input-msg auto-grow-input__placeholder" v-if="value === ''">{{ placeholder }}</div>

		<div class="container-msg-input">
			<div class="input-msg auto-grow-input__input" :contenteditable="!disabled" v-on="inputListeners" ref="input"></div>
		
			<div class="action" @click="$emit('sendMessage')" >
				
				<svgicon icon="sendMessage"/>
			</div>
		
		 </div>
		
	</div>
</template>

<script>
const decodeEntities = (function () {
  // This prevents any overhead from creating the object each time
  const element = document.createElement('div')

  // Regular expression matching HTML entities
  const entity = /&(?:#x[a-f0-9]+|#[0-9]+|[a-z0-9]+);?/ig

  return function decodeHTMLEntities(str) {
    // find and replace all the html entities
    str = str.replace(entity, function (m) {
      element.innerHTML = m
      return element.textContent
    })

    // Reset the value
    element.textContent = ''

    return str
  }
})()

/**
 * Convert html to safe text
 */
export const htmlToText = html => {
  // Convert user links to [user id] [/user]
  html = html.replace(/<a[^>]+href="[^"]*\/users\/([a-z0-9-]+)\/profile"[^>]+>(.*?)<\/a>/g, (_, id, content) => {
    return `[user ${id}]${content}[/user]`
  })

  // Convert home links to [home id] [/home]
  html = html.replace(/<a[^>]+href="[^"]*\/users\/annonce\/([a-z0-9-]+)"[^>]+>(.*?)<\/a>/g, (_, id, content) => {
    return `[home ${id}]${content}[/home]`
  })

  // Remove entities
  html = decodeEntities(html)

  // Remove html tags
  const tags = /<\/?([a-z0-9]*)\b[^>]*>?/gi
  const commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi

  // Recursively remove tags to ensure that the returned string doesn't contain forbidden tags after previous passes (e.g. '<<bait/>switch/>')
  let res = html
  while (true) {
    const before = res
    res = before.replace(commentsAndPhpTags, '').replace(tags, ($0, $1) => {
      return ''
    })

    // Return once no more tags are removed
    if (before === res) {
      return res
    }
  }
}

/**
 * Convert text to safe html
 */
export const textToHTML = value => {
  // Escape html
  const ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }
  value = value.replace(/[&<>'"]/g, c => ESC_MAP[c])

  // Convert [user id] [/user] to links
  value = value.replace(/\[user ([a-z0-9-]+)\](.*?)\[\/user\]/g, (_, id, content) => {
    return `<a href="/users/${id}/profile" target="_blank">${content}</a>`
  })

  // Convert [home id] [/home] to links
  value = value.replace(/\[home ([a-z0-9-]+)\](.*?)\[\/home\]/g, (_, id, content) => {
    return `<a href="/users/annonce/${id}" target="_blank">${content}</a>`
  })

  // Remove empty tags
  return value.replace(/\[\/?(home|user)[^\]]*\]/g, (_, id, content) => {
    return `<a href="/users/annonce/${id}" target="_blank">${content}</a>`
  })
}

export default {
  props: {
    disabled: Boolean,
    value: String,
    placeholder: String,
    maxlength: Number,
  },
  data: () => ({
    raw_value: '',
  }),
  mounted() {
    this.raw_value = this.value
    this.$refs.input.innerHTML = textToHTML(this.value)
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        keydown: this.onKeydown,
      }
    },
  },
  methods: {
    focus() {
      const el = this.$refs.input
      el.focus()
      const range = document.createRange()
      range.selectNodeContents(el)
      range.collapse()
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    onInput(ev) {
      this.raw_value = htmlToText(this.$refs.input.innerHTML)
      if (this.maxlength) {
        this.raw_value = this.raw_value.substring(0, this.maxlength)
      }
      this.$emit('input', this.raw_value)
    },
    onKeydown(ev) {
      if (this.maxlength && this.raw_value.length >= this.maxlength && ev.key.length === 1) {
        return ev.preventDefault()
      }
      this.$emit('keydown', ev)
    },
  },
  watch: {
    value(value) {
      if (this.raw_value !== value) {
        this.raw_value = value
        this.$refs.input.innerHTML = textToHTML(value)
      }
    },
  },
}
</script>

<style lang="scss">

.send-msg {
	padding-top: 5px;
	padding-right: 5px;
	float: right;
}

.input-msg {

	width: 95%;
}

.container-msg-input {
	display: flex;
    justify-content: space-between;
}

.action {
	align-items: center;
    display: flex;
    justify-content: center;
	width: 10%;
}

.auto-grow-input {
	position: relative;

	&__placeholder {
		opacity: 0.5;
		position: absolute;
		user-select: none;
		pointer-events: none;
	}
	&__input, &__placeholder {
		padding: 8px;
		outline: none;
		overflow-wrap: break-word;
		height: 100%;
		line-height: 20px;
	}
	&--disabled {
		background-color: #c8c2c033;
	}
}
</style>
